import { HttpClient, HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ParametroAccionService } from 'src/app/Services/parametro-accion.service';
import { environment } from 'src/environments/environment';
import { ModalRechSolComponent } from '../modal-rech-sol/modal-rech-sol.component';
import { ModalAproSolComponent } from '../modal-apro-sol/modal-apro-sol.component';

@Component({
  selector: 'app-det-solicitud',
  templateUrl: './det-solicitud.component.html',
  styleUrls: ['./det-solicitud.component.css']
})
export class DetSolicitudComponent implements OnInit {

  private getsolicitud:string = environment.detsolicitud;
  private getdoctos:string = environment.getdoctos;
  form: FormGroup;
  formulario: FormGroup;
  params: any;
  archivo_1: number;
  archivo_2: number;
  rutr: any;
  rute: any;
  seq: any;
  item:any;
  estado:any;

  constructor(public parametroAccion : ParametroAccionService, private http: HttpClient, private fb: FormBuilder,private router: Router, private toastr: ToastrService, private modalService: NgbModal) {

    this.form = this.fb.group({
      solicitud: []
    });

    this.formulario = this.fb.group({
      nroSol: [],
      estSol: [],
      rutEmpr: [],
      razonSocial: [],
      rutRep: [],
      nombreRep: [],
      correoRep: [],
      creationDate: []
    });

    this.cargarDatos();
  }

  cargarDatos(){
    this.params = this.parametroAccion.obtenerDatos();
    this.item = this.params;
    //console.log(this.params);
    if (this.params) {
      this.params.forEach(element => {
        this.formulario.controls['nroSol'].setValue(element.SEQ_NRO_SOLICITUD_CDG);
        this.formulario.controls['estSol'].setValue(element.DESCRIPCION_ESTADO);
        this.formulario.controls['rutEmpr'].setValue(element.RUT_EMPRESA+"-"+element.DV_EMPRESA);
        this.formulario.controls['razonSocial'].setValue(element.RAZON_SOCIAL);
        this.formulario.controls['rutRep'].setValue(element.RUT_REPRESENTANTE+"-"+element.DV_REPRESENTANTE);
        this.formulario.controls['nombreRep'].setValue(element.NOMBRE_REPRESENTANTE_LEGAL);
        this.formulario.controls['correoRep'].setValue(element.CORREO_ELECTRONICO);
        this.formulario.controls['creationDate'].setValue(element.CREATION_DATE);
        this.archivo_1=element.ARCHIVO_1;
        this.archivo_2=element.ARCHIVO_2;
        this.rutr = element.RUT_REPRESENTANTE;
        this.rute = element.RUT_EMPRESA;
        this.seq = element.SEQ_NRO_SOLICITUD_CDG;
        this.estado = element.CODIGO_ESTADO;
        //this.formulario.patchValue(this.params);
      });
      this.formulario.get('nroSol').disable();
      this.formulario.get('estSol').disable();
      this.formulario.get('rutEmpr').disable();
      this.formulario.get('razonSocial').disable();
      this.formulario.get('rutRep').disable();
      this.formulario.get('nombreRep').disable();
      this.formulario.get('correoRep').disable();
      this.formulario.get('creationDate').disable();
    }
  }

  ngOnInit(): void {
  }

  onSubmit(){
    this.getDetalle(this.form.get('solicitud').value);
    /*this.http.post<any>(this.getsolicitud, { 
      numero_solicitud:this.form.get('solicitud').value
    }, { observe: 'response' }).subscribe((response: HttpResponse<any>) => {
      const status = response.status;
      const data = response.body;
      if (status===200) { 
        if (data.totalRecords>0) {
          this.parametroAccion.guardarDatos(data.Consulta);
          
          this.cargarDatos();
        }else{
          this.toastr.error("No se encuentra registro.");
        }
      }else{
        this.toastr.error("No se encuentra registro.");
      }
    }, err => {
      console.log("error capturado");
      console.log(err);
    });*/
  }

  getDetalle(solic){
    this.http.post<any>(this.getsolicitud, { 
      numero_solicitud:solic
    }, { observe: 'response' }).subscribe((response: HttpResponse<any>) => {
      const status = response.status;
      const data = response.body;
      if (status===200) { 
        if (data.totalRecords>0) {
          this.parametroAccion.guardarDatos(data.Consulta);
          
          this.cargarDatos();
        }else{
          this.toastr.error("No se encuentra registro.");
        }
      }else{
        this.toastr.error("No se encuentra registro.");
      }
    }, err => {
      console.log("error capturado");
      console.log(err);
    });
  }

  onBack(){
    this.router.navigate(['/primer']);
  }

  downloadFile1(){
    let llave1 = this.rutr;
    let llave2 = this.rute;
    let llave3 = this.seq;
    /*let llave1 = item.RUT_REPRESENTANTE;
    let llave2 = item.RUT_EMPRESA;
    let llave3 = item.SEQ_NRO_SOLICITUD_CDG;*/
    this.downloadFile(llave1, llave2, llave3, "0");
  }

  downloadFile2(){
    let llave1 = this.rutr;
    let llave2 = this.rute;
    let llave3 = this.seq;
    /*let llave1 = item.RUT_REPRESENTANTE;
    let llave2 = item.RUT_EMPRESA;
    let llave3 = item.SEQ_NRO_SOLICITUD_CDG;*/
    this.downloadFile(llave1, llave2, llave3, "1");
  }

  downloadFile(llave1: String, llave2: String, llave3: String, llave4: String){
    let filename:String;
    let urlPDF: String;
    this.http.post<any>(this.getdoctos, { 
      rut_representante : llave1,
      rut_empresa       : llave2,
      nrosolicitud      : llave3,
      nroarchivo        : llave4
    }, { observe: 'response' }).subscribe((response: HttpResponse<any>) => {
      const status = response.status;
      const data = response.body;
      if (status===200) { 
        filename = data.nombre;
        urlPDF = data.URL;
        window.open(data.URL, '_blank');
        //this.haySolPend=true;
        //this.solPendientes=data.Consulta;
      }
    }, err => {
      console.log("error capturado");
      console.log(err);
    });
  }

  openModalA() {
    this.parametroAccion.guardarDatos(this.item);
    const modalRef =this.modalService.open(ModalAproSolComponent, {
      backdrop: 'static', // Aquí estableces 'static' como el valor del backdrop
      keyboard: false,     // Esto desactiva la capacidad de cerrar el modal con la tecla Esc
      centered:true
    });
    modalRef.result.then(
      () => {
        this.getDetalle(this.item[0].SEQ_NRO_SOLICITUD_CDG);
      },
      () => {
        this.getDetalle(this.item[0].SEQ_NRO_SOLICITUD_CDG);
      }
    );
  }

  openModalR() {
    this.parametroAccion.guardarDatos(this.item);
    const modalRef =this.modalService.open(ModalRechSolComponent, {
      backdrop: 'static', // Aquí estableces 'static' como el valor del backdrop
      keyboard: false,     // Esto desactiva la capacidad de cerrar el modal con la tecla Esc
      centered:true
    });
    modalRef.result.then(
      () => {
        // El modal se cerró correctamente
        //this.getSolPendientes();
        this.getDetalle(this.item[0].SEQ_NRO_SOLICITUD_CDG);
        //this.cargarDatos();
      },
      () => {
        // Se cerró el modal con dismiss
        //this.getSolPendientes();
        this.getDetalle(this.item[0].SEQ_NRO_SOLICITUD_CDG);
        //this.cargarDatos();
      }
    );
  }

}
